<script setup>
    import Navbar from '@guest/shared/nav/Navbar.vue';
    // import Breadcrumb from '@guest/shared/nav/Breadcrumb.vue';
    import Footer from '@guest/shared/nav/Footer.vue';
    import GuestAlertModals from '@guest/shared/layouts/GuestAlertModals.vue';
    import { onMounted } from 'vue';
    import GlobalModals from '@/components/GlobalModals.js';

    onMounted(() => {
        GlobalModals.initialize();
    });
</script>

<template>
    <Navbar />
    <!--    <Breadcrumb/>-->

    <slot />

    <Footer />

    <GuestAlertModals />
</template>

<style scoped></style>
